import { Logger, ErrorHandlingUtils, ReduxUtils, DeviceDetectionUtils } from 'UI-Dash-Commons-UI';

import { LOCAL_STORE_IS_LEFT_MENU_PINNED_CLOSED } from './constants';
import SectionUtils from '../utils/SectionUtils';
import MenuSection from '../../../types/MenuSection';

import * as constants from './constants';
import MainNavigationState from "../types/MainNavigationState";

const TAG = 'MainNavigation-reducer';

const createInitialNavigationState: () => MainNavigationState = () =>
{
    let isMobileDevice: boolean = DeviceDetectionUtils.isMobileDevice();

    if ( localStorage.getItem( LOCAL_STORE_IS_LEFT_MENU_PINNED_CLOSED ) === 'true' )
    {
        isMobileDevice = true;
    }

    return {
        menuSpec: {
            bottomLeftMenu: null,
            debugInfo: [],
            leftSideMenu: null,
            permissions: null,
            topButtonsMenu: null,
            topDropdownMenu: null
        },

        leftMenuState: {
            isOpen: !isMobileDevice, // Left menu closed on mobile devices by default
            isPinnedOpen: !isMobileDevice, // Pinned closed on mobile devices by default
            openSectionId: '',
            lastLoadTimeStamp: '',
        },

        debugInfoState: {
            isOpen: false,
            data: null
        },

        contentHeight: 250
    };
};

const activateLeftMenuSection = ( state: MainNavigationState, action: any ) => ( {
    ...state,
    menuSpec: {
        ...state.menuSpec,

        leftSideMenu: {
            ...state.menuSpec.leftSideMenu,

            activeSection: action.sectionSpec
        }
    },

    leftMenuState: {
        ...state.leftMenuState,

        openSectionId: SectionUtils.findOpenSectionId( state.menuSpec.leftSideMenu, action.sectionSpec )
    }
} );

const onMenuSpecFetchSuccess = ( state: MainNavigationState, action: any ) => ( {
    ...state,
    menuSpec: {
        ...action.menuSpec
    },

    leftMenuState: {
        ...state.leftMenuState,

        openSectionId: SectionUtils.findOpenSectionId( action.menuSpec.leftSideMenu, action.menuSpec.leftSideMenu.activeSection )
    }
} );

const onMenuSpecFetchError = () =>
{
    // If we are here we can't render anything, assume we are not logged in
    // and force a log out
    Logger.error( TAG, 'Unable to fetch menu spec: forcing a log out' );

    ErrorHandlingUtils.handleCriticalError( 400 );

    return null;
};

const updateSideLeftMenuLoadTimeStamp = ( state, action ) => ( {
    ...state,

    leftMenuState: {
        ...state.leftMenuState,

        lastLoadTimeStamp: action.lastLoadTimeStamp
    }
} );

const updateSideLeftMenuOpenState = ( state: MainNavigationState, action: any ) =>
{
    let activeSection: MenuSection | null = null;

    if ( state.menuSpec.leftSideMenu )
    {
        activeSection = state.menuSpec.leftSideMenu.activeSection;
    }


    return {
        ...state,

        leftMenuState:
            {
                ...state.leftMenuState,

                isOpen: action.isOpen,
                openSectionId: SectionUtils.findOpenSectionId( state.menuSpec.leftSideMenu, activeSection )
            }
    };
};

const updateSideLeftOpenSectionId = ( state: MainNavigationState, action: any ) => ( {
    ...state,

    leftMenuState: {
        ...state.leftMenuState,

        openSectionId: action.sectionId
    }
} );

const updateSideLeftPinnedOpenSection = ( state: MainNavigationState, action: any ) =>
{

    localStorage.setItem( LOCAL_STORE_IS_LEFT_MENU_PINNED_CLOSED, ( !action.isPinnedOpen ).toString() );

    return {
        ...state,

        leftMenuState: {
            ...state.leftMenuState,

            isPinnedOpen: action.isPinnedOpen
        }
    };
};

const updateDebugInfoOpenState = ( state: MainNavigationState, action: any ) => ( {
    ...state,

    debugInfoState: {
        ...state.debugInfoState,

        isOpen: action.isOpen
    }
} );

const updateDebugInfoDataState = ( state: MainNavigationState, action: any ) => ( {
    ...state,

    debugInfoState: {
        ...state.debugInfoState,

        data: action.data
    }
} );

const navBarReducer = ReduxUtils.createReducer( createInitialNavigationState(), {
        [ constants.ACTION_ACTIVATE_LEFT_MENU_SECTION ]: activateLeftMenuSection,
        [ constants.ACTION_ON_MENU_SPEC_FETCH_ERROR ]: onMenuSpecFetchError,
        [ constants.ACTION_ON_MENU_SPEC_FETCH_SUCCESS ]: onMenuSpecFetchSuccess,
        [ constants.ACTION_UPDATE_DEBUG_INFO_DATA_STATE ]: updateDebugInfoDataState,
        [ constants.ACTION_UPDATE_DEBUG_INFO_OPEN_STATE ]: updateDebugInfoOpenState,
        [ constants.ACTION_UPDATE_SIDE_MENU_OPEN_STATE ]: updateSideLeftMenuOpenState,
        [ constants.ACTION_UPDATE_SIDE_MENU_PINNED_OPEN_STATE ]: updateSideLeftPinnedOpenSection,
        [ constants.ACTION_UPDATE_SIDE_MENU_TIME_STAMP_STATE ]: updateSideLeftMenuLoadTimeStamp,
        [ constants.ACTION_UPDATE_SIDE_OPEN_SECTION_ID ]: updateSideLeftOpenSectionId,
    } )
;

export default navBarReducer;
